import { connect } from 'react-redux';
import CreateInvoiceRutinPPDB from '../../../../views/Finance/Spp/CreateInvoice/CreateInvoiceRutinPPDB.view';
import { getStudent } from '../../../../states/thunks/student.thunk';
import { getInvoiceRutin, editInvoiceRutin, saveInvoiceRutin } from '../../../../states/thunks/academics.thunk'
import { getYearsOfEducationsOptions, getPrmPayments } from '../../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    user: state.user,
    result: state.result,
  }
}

function mapDispatchToProps(dispatch){
  return{
    handleGetStudent: () => dispatch(getStudent()),
    handleGetInvoiceRutin: payload => dispatch(getInvoiceRutin(payload)),
    handleEditInvoiceRutin: (payload, goback) => dispatch(editInvoiceRutin(payload, goback)),
    handleSaveInvoiceRutin: (payload, goback) => dispatch(saveInvoiceRutin(payload, goback)),
    getYearsOfEducationsOptions: (payload) => dispatch(getYearsOfEducationsOptions(payload)),
    getPrmPayments: (payload) => dispatch(getPrmPayments(payload)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps) (CreateInvoiceRutinPPDB);